(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('teamSection', teamSection);

    /* @ngInject */
    function teamSection($sce, $http, $rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'team-section.tpl',
            controller: teamSectionCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                sellerId: '<',
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.data.query_customs.team.hq.stats = {
                total: 0,
                sold: 0,
                // days2go: scope.vm.data.query[0].customs.seller_data.hq.stats.days2go,
                days2go: $rootScope.globals.site_options.shopping_cart_settings.days2go,
                // pie_price: scope.vm.data.query[0].customs.seller_data.hq.stats.pie_price
                pie_price: parseInt($rootScope.globals.site_options.shopping_cart_settings['pie-price'])
            };
            /*
            angular.forEach(scope.vm.data.query, function(seller, sidx) {
                scope.vm.data.query_customs.team.hq.stats.total += scope.vm.data.query[sidx].customs.seller_data.hq.stats.total;
                scope.vm.data.query_customs.team.hq.stats.sold += scope.vm.data.query[sidx].customs.seller_data.hq.stats.sold;
            });
            */
            scope.vm.data.query_customs.team.hq.stats.total = scope.vm.data.query_customs.team.totals.total;
            scope.vm.data.query_customs.team.hq.stats.sold = scope.vm.data.query_customs.team.totals.pies;
            if(!scope.vm.data.query_customs.team.description.value) {
                scope.vm.data.query_customs.team.description.value = $rootScope.globals.site_options.seller_team_defaults.team_default_text;
            }
            scope.vm.youtube = '';
            if (scope.vm.data.query_customs.team.hq.video.value) {
                scope.vm.getUrl = function(id) {
                    return '//www.youtube.com/embed/' + id + '?rel=0';
                };
                scope.vm.youtube = $sce.trustAsHtml('<iframe width="560" height="315" src="' + scope.vm.getUrl(scope.vm.data.query_customs.team.hq.video.value) + '" frameborder="0" allowfullscreen></iframe>');
            }

            if (!scope.vm.data.query_customs.team.hq["page-image"].value) {
                scope.vm.data.query_customs.team.hq["page-image"].value = $rootScope.globals.site_options.seller_team_defaults.team_default_image;
            }

            if (scope.vm.data.query_customs.team.hq['video-image'].value == 'image') {
                scope.vm.youtube = '';
            }

            if (angular.isDefined(scope.vm.data.query_customs.team.inline_edit)) {
                scope.vm.data.inline_edit = true;
            }


            if(scope.vm.data.stats.found_posts > 0) {
                if (angular.isUndefined(scope.vm.data.query_customs.team.hq.goal)) {
                    scope.vm.data.query_customs.team.hq.goal =  {value: 0};
                }
                var sumSellersGoal = false;
                if (!scope.vm.data.query_customs.team.hq.goal.value) {
                    scope.vm.data.query_customs.team.hq.goal.value = 0;
                    sumSellersGoal = true;
                }

                if (scope.$root.project_has_opt("layoutCS")) {
                    scope.vm.data.query_customs.team.hq.goal.value = 0;
                    sumSellersGoal = true;
                }

                angular.forEach(scope.vm.data.query, function(seller, sidx) {
                    if (angular.isDefined(scope.vm.data.query[sidx].customs.seller_data.photo.value.sizes) &&
                      angular.isDefined(scope.vm.data.query[sidx].customs.seller_data.photo.value.sizes.thumbnail)) {
                        scope.vm.data.query[sidx].img = seller.customs.seller_data.photo.value.sizes.thumbnail.url;
                    } else {
                        scope.vm.data.query[sidx].img = $rootScope.globals.default.individualImg;
                    }
                    if (sumSellersGoal) {
                        console.log('here');
                        scope.vm.data.query_customs.team.hq.goal.value += (scope.vm.data.query[sidx].customs.seller_data.hq.goal.value ? parseInt(scope.vm.data.query[sidx].customs.seller_data.hq.goal.value) : 0);
                    }
                });
            }

            // console.log(scope.vm.pageDescription);


            // scope.vm.$jed = angular.element(element).find('.seller-description .editor').first();
            scope.vm.temp = '';

            scope.vm.doEdit = function(e) {
                console.log('doEdit');
                scope.vm.inEdit = true;
                // scope.vm.$jed.attr({ contenteditable: true });
                scope.vm.temp = scope.vm.data.query_customs.team.description.value;
            };

            scope.vm.doExit = function(e) {
                console.log('doExit');
                // scope.vm.$jed.attr({ contenteditable: false });
                scope.vm.data.query_customs.team.description.value = scope.vm.temp;
                scope.vm.inEdit = false;
            };

        }

    }

    /* @ngInject */
    function teamSectionCtrl($scope, $rootScope, $http) {
        $scope.vm.baseurl = baseurl;
        // $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';

        $rootScope.selectedSeller = undefined;
        $rootScope.selectedSellerName = '';
        $scope.selectSeller = function(sellerID, firstName, lastName) {
            $rootScope.selectedSeller = sellerID;
            $rootScope.selectedSellerName = lastName + ', ' + firstName;
            //console.log(['sellerID - ', $rootScope.selectedSeller]);
            //console.log(['sellerName - ', $rootScope.selectedSellerName]);
        };

        $scope.vm.inEdit = false;
        $rootScope.uploadMediaValue = '';
        $rootScope.uploadImg = false;
        $scope.vm.openUpload = function(uploadImg, uploadMediaValue) {
            $rootScope.uploadImg = uploadImg;
            $rootScope.uploadMediaValue = uploadMediaValue;
            $rootScope.openModal("upload-media");
            //console.log($rootScope.uploadImg, $rootScope.uploadMediaValue);
        };

        $scope.saving = false;
        $scope.saveTeam = function() {
            $scope.ajaxIt('save_team_data', {description: {
                value: $scope.vm.data.query_customs.team.description.value
            }});
        };

        $scope.ajaxIt = function(method, data) {
            if (!$scope.saving) {
                $scope.saving = true;
                $scope.vm.inEdit = false;

                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: method,
                    nonce: $scope.$root.stats.nonce,
                    params: data
                }).then(function(response) {
                    $scope.saving = false;
                });
            }
        };
    }

})();